<template>
  <div>
    <div class="BlockList">
      <div class="BlockList-W">
        <div class="BlockList_Inp">
          <Homseach></Homseach>
        </div>
      </div>
    </div>
    <!-- <div>
      <Seacher></Seacher>
    </div> -->
    <div class="ValidatorBetail">
      <div class="ValidatorBetail-W">
        <div class="Homeinput"></div>
        <div class="BkHeight_conent">
          <div class="BkHeight_center">
            <div class="BkHeight_l">
              <!-- <img src="../../../assets/pc/Index/active.png" /> -->
              <img :src="logo" />
            </div>
            <div class="BkHeight_r">
              <div class="BkHeight_rs">
                <div class="BK_name">{{ name }}</div>
                <div class="Bk_vs">Version {{ version }}</div>
              </div>
              <div class="BkHeight_rx">
                <div
                  class="address"
                  @click="fromAddress(address)"
                  style="cursor: pointer"
                >
                  {{ address }}
                </div>
                <img
                  src="@/assets/pc/Index/copy.png"
                  v-clipboard:copy="address"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  @click="msg(index)"
                />
              </div>
            </div>
            <!-- <div class="BkHeight_rr">
              <div>Delegate now</div>
            </div> -->
          </div>
          <div class="BkHeight_conent_header">
            <p>
              <span>Validator detail</span>
            </p>
          </div>
          <div class="BkHeight_conent_Ul">
            <ul>
              <li>
                <p>Self - Staked :</p>
                <p>{{ Number(selfStake).toLocaleString() }} TTOS</p>
              </li>
              <li>
                <p>Delegator Stake :</p>
                <p>{{ delegated }} TTOS</p>
              </li>
              <li>
                <p>Delegation Cap :</p>
                <p>{{ Number(65000).toLocaleString() }}</p>
              </li>
              <li>
                <p>Filled :</p>
                <p>{{ Number((delegated / 65000) * 100).toFixed(2) }}%</p>
              </li>
              <li>
                <p>Delegators :</p>
                <p>{{ Number(delegators).toLocaleString() }}</p>
              </li>
              <li>
                <p>Workload :</p>
                <p>{{ Number(workload).toLocaleString() }}</p>
              </li>
              <li>
                <p>Active :</p>

                <p><img :src="ImgUrl" /></p>
                <!-- <p><img src="@/assets/pc/Index/active.png" /></p> -->
              </li>
              <li>
                <p>Online :</p>
                <p>{{ online }}</p>
              </li>
              <!-- <li v-for="(item, index) in list" :key="index">
                <p>{{ item.Block }}</p>
                <p ref="ele" :class="OnlineIndex == 1 ? 'active' : ''">
                  {{ item.BlockHeight }}
                  <img
                    src="@/assets/pc/BkHash/BkHash1.png"
                    alt=""
                    v-if="index === 1"
                    v-clipboard:copy="copyContent"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    @click="msg(index)"
                  />
                  <img :src="ImgUrl" v-if="index == 5" />
                </p>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="Workload">
          <div class="Workload_list">
            <div class="Workload_head1">
              Historical Workload<span
                >(Show the workload for the past
                {{ historyWorkload.length }} days.)</span
              >
            </div>

            <div class="Workload_con">
              <!-- <div class="con_box" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" v-for="(item,index) in 10" :key="index"> -->
              <el-tooltip
                placement="top"
                v-for="(item, index) in historyWorkload"
                :key="index"
              >
                <div slot="content">
                  <div
                    style="
                      color: #8e9093;
                      font-size: 12px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      font-weight: 400;
                    "
                  >
                    Workload :
                    <span style="color: #fff">{{ item.workload }}</span>
                  </div>
                  <br />
                  <div
                    style="
                      color: #8e9093;
                      font-size: 12px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      font-weight: 400;
                    "
                  >
                    Workload benchmark :
                    <span style="color: #fff">{{
                      item.workloadBenchMark
                    }}</span>
                  </div>
                  <br />
                  <div
                    style="
                      color: #8e9093;
                      font-size: 12px;
                      font-family: Source Han Sans CN-Regular,
                        Source Han Sans CN;
                      font-weight: 400;
                    "
                  >
                    Bonus Earnings percentage :
                    <span
                      style="color: #fff"
                      v-if="item.workload !== 0 && item.workloadBenchMark !== 0"
                    >
                      {{
                        (item.workload / item.workloadBenchMark > 1
                          ? 100
                          : (item.workload / item.workloadBenchMark) * 100
                        ).toFixed(2) + "%"
                      }}</span
                    >
                    <span v-else>0%</span>
                  </div>
                  <br />
                  <div
                    @click="handleMouseEnter"
                    style="text-align: right; color: #06c083; cursor: pointer"
                  >
                    View Calculation Rules
                  </div>
                </div>
                <div class="container">
                  <div
                    :class="
                      item.workload > item.workloadBenchMark
                        ? 'content green'
                        : 'content red'
                    "
                  >
                    <!-- <div
                      :class="item.workload > item.workloadBenchMark?'progress':'progressa'"
                      :style=" {
                        height:
                          (item.workload / item.workloadBenchMark) * 100 + '%'}"
                    ></div> -->
                    <div
                      :class="
                        item.workload > item.workloadBenchMark
                          ? 'progress'
                          : 'progressa'
                      "
                      :style="{
                        height:
                          (item.workload / item.workloadBenchMark > 1
                            ? 100
                            : (item.workload / item.workloadBenchMark) * 100) +
                          '%',
                      }"
                    ></div>

                    <div class="text">
                      <div class="time1">{{ item.moth }}</div>
                      <div class="time1">{{ item.day }}</div>
                    </div>
                  </div>
                </div>
                <!-- <div
                  :class="
                    item.workload > item.workloadBenchMark
                      ? 'con_box con_boxg'
                      : 'con_box con_boxr'
                  "
                  
                ><div class="progress-bar" :style="{ height: (item.workload / item.workloadBenchMark * 100) + '%' }"></div>
                  <div class="time1">{{ item.moth }}</div>
                  <div class="time1">{{ item.day }}</div>
                  
                </div> -->
              </el-tooltip>
              <!-- 弹框开始 -->
              <div class="tanks" v-show="flag">
                <div class="tanks_box">
                  <div class="tanks_tit">
                    <div class="tanks_titl">Calculation Rules</div>
                    <img
                      src="@/assets/pc/TopValidators/close.png"
                      @click="close"
                    />
                  </div>
                  <div class="tanks_cons">
                    <div class="consli">
                      <span>1.</span>
                      <div>
                        Collect the number of validators and their workloads who
                        have propagated signatures for all blocks on the current
                        day.
                      </div>
                    </div>
                    <div class="consli">
                      <span>2.</span>
                      <div>
                        Obtain the total number of blocks generated on the day.
                      </div>
                    </div>
                    <div class="consli">
                      <span>3.</span>
                      <div>
                        Calculate the benchmark workload value:
                        workloadBenchmark = (Total Blocks Generated on the Day *
                        7) / Number of Validators with Signature Propagation.
                      </div>
                    </div>
                    <div class="consli">
                      <span>4.</span>
                      <div>
                        If the validator's workload is greater than the
                        benchmark workload value, they are eligible to receive
                        the full rewards for the day. Otherwise, distribute
                        rewards based on the percentage of actual workload
                        compared to the benchmark workload value.
                      </div>
                    </div>
                    <!-- <div class="consli">
                      <span>5.</span>
                      <div>
                        Addresses with signatures below the calculated average
                        will be ineligible for claiming rewards.
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <!-- 弹框结束 -->
              <!-- 
              <div class="con_box">
                <div class="time1">Aug</div>
                <div class="time1">17</div>
              </div>
              <div class="con_box">
                <div class="time1">Aug</div>
                <div class="time1">17</div>
              </div>
              <div class="con_box">
                <div class="time1">Aug</div>
                <div class="time1">17</div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="TopValidatorsList">
          <div class="Blocks">
            <div class="Block_Top notranslate">
              <span>Delegations</span>
              <!-- <span v-if="IsShowS == true"
          ><Pagination
            @PaginationChanage="CurrentChange($event)"
            :Total="total"
            :Page="Page1"
        /></span> -->
            </div>
            <div class="Block_list" v-if="IsShowS == true">
              <ul class="block_list_Top">
                <li>Address</li>
                <li>Created On</li>
                <li>Amount</li>
              </ul>
            </div>
            <div class="Block_List_center" v-if="IsShowS == true">
              <ul>
                <li
                  v-for="(item, index) in list"
                  :key="index"
                  class="notranslate"
                >
                  <p>
                    <span @click="fromAddress(item.fromAddress)">{{
                      item.fromAddress
                    }}</span>
                  </p>
                  <p>
                    <span>
                      {{ item.tradeTime }}
                      <span class="Hover1">
                        <span class="Hover"
                          >{{ TimeDate[index]
                          }}<i class="iconfont">&#xe600;</i></span
                        >
                      </span>
                    </span>
                  </p>
                  <p>
                    {{
                      new Intl.NumberFormat("en-US", {
                        minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                        maximumFractionDigits: 10,
                      }).format(item.amount)
                    }}
                    TTOS
                  </p>
                </li>
              </ul>
            </div>
            <div class="Block_List_Bottom" v-if="IsShowS == true">
              <!-- <Pagination2
                @PaginationChanage="CurrentChange($event)"
                :Total="total"
                :Page="PaginationIndex"
              /> -->
              <el-pagination
                ref="Pagination"
                :page-size="10"
                :current-page.sync="PaginationIndex"
                background
                layout="prev, pager,
      next"
                @current-change="CurrentChange"
                :total="total"
              >
              </el-pagination>
            </div>
            <div v-if="IsShowS == false">
              <div class="Img">
                <img src="@/assets/pc/BkHash/zanwushuju.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";
// import Pagination from "../BlockList/Pagination";
// import Pagination2 from "../BlockList/Pagination";
import { GetvalidatorDetail } from "@/assets/server/api";
import { timestampConvertTime, formatSeconds, getSubStr } from "@/utils/utils";
export default {
  props: ["Address"],
  data() {
    return {
      list: [],
      PaginationIndex: 1,
      total: null,
      address: "",
      Page1: "",
      TimeDate: [],
      IsShowS: true,
      // listall:[],
      selfStake: "",
      delegated: "",
      delegators: "",
      workload: "",
      active: "",
      online: "",
      version: "",
      name: "",
      logo: "",
      img: require("../../../assets/pc/Index/active.png"),
      LogoImg: require("@/assets/pc/Index/vers1.png"),
      ImgUrl: "",
      historyWorkload: [],
      flag: false,
    };
  },
  components: {
    // Pagination,
    // Pagination2,
    Homseach,
  },
  watch: {
    deep: true,
    Address(val) {
      // console.log(val);
      // this.listall=val;
      this.address = val;
      this.Delegations();
    },

    //
  },
  created() {
    this.PaginationIndex = 1;
    this.address = this.$route.query.address;
  },
  mounted() {
    this.PaginationIndex = 1;
    this.Delegations();
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  methods: {
    handleMouseEnter() {
      //  console.log("鼠标移入");
      this.flag = true;
    },
    close() {
      this.flag = false;
    },
    // handleMouseLeave() {
    //   console.log("鼠标移出");
    // },
    onCopy(e) {
      //  console.log(e);
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    CurrentChange(e) {
      this.PaginationIndex = e;
      this.Delegations();
      //this.Page1 = this.getContextData("tiaozhuan") || 1;
      //  this.Page1 = this.getContextData("tiaozhuan") || 1;
    },
    Delegations() {
      const params = {
        address: this.address,
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      GetvalidatorDetail(formData).then((res) => {
        this.total = Number(res.result.count);
        //  console.log(res);
        this.address = res.result.validatorInfo.address;
        this.selfStake = res.result.validatorInfo.selfStake;
        this.delegated = res.result.validatorInfo.delegated;
        this.delegators = res.result.validatorInfo.delegators;
        this.workload = res.result.validatorInfo.workload;
        this.active = res.result.validatorInfo.active;
        this.online = res.result.validatorInfo.online;
        this.version = res.result.validatorInfo.version;
        this.name = res.result.validatorInfo.name;
        this.logo = res.result.validatorInfo.logo;
        this.historyWorkload = res.result.validatorInfo.historyWorkload;
        //console.log(this.historyWorkload);
        if (this.historyWorkload !== "" || this.historyWorkload == null) {
          this.historyWorkload = JSON.parse(this.historyWorkload);
        }
        //     console.log(this.historyWorkload);
        // console.log(JSON.parse(this.historyWorkload))
        for (var i = 0; i < this.historyWorkload.length; i++) {
          this.historyWorkload[i].moth =
            this.historyWorkload[i].time.split("-")[1];
          this.historyWorkload[i].day =
            this.historyWorkload[i].time.split("-")[2];
          if (this.historyWorkload[i].moth == "01") {
            this.historyWorkload[i].moth = "Jan";
          } else if (this.historyWorkload[i].moth == "02") {
            this.historyWorkload[i].moth = "Feb";
          } else if (this.historyWorkload[i].moth == "03") {
            this.historyWorkload[i].moth = "Mar";
          } else if (this.historyWorkload[i].moth == "04") {
            this.historyWorkload[i].moth = "Apr";
          } else if (this.historyWorkload[i].moth == "05") {
            this.historyWorkload[i].moth = "May";
          } else if (this.historyWorkload[i].moth == "06") {
            this.historyWorkload[i].moth = "Jun";
          } else if (this.historyWorkload[i].moth == "07") {
            this.historyWorkload[i].moth = "Jul";
          } else if (this.historyWorkload[i].moth == "08") {
            this.historyWorkload[i].moth = "Aug";
          } else if (this.historyWorkload[i].moth == "09") {
            this.historyWorkload[i].moth = "Sep";
          } else if (this.historyWorkload[i].moth == "10") {
            this.historyWorkload[i].moth = "Oct";
          } else if (this.historyWorkload[i].moth == "11") {
            this.historyWorkload[i].moth = "Nov";
          } else if (this.historyWorkload[i].moth == "12") {
            this.historyWorkload[i].moth = "Dec";
          }
        }
        //    console.log(this.historyWorkload);
        if (this.name == "") {
          this.name = getSubStr(this.address, 0, 4);
        }
        if (this.logo == "") {
          this.logo = this.LogoImg;
          // this.logo="@/assets/pc/BkHash/BkHash1.png"
        }
        if (this.active == 0) {
          this.ImgUrl = require("../../../assets/pc/TopValidators/TopValidators5.png");
        } else if (this.active == 1) {
          this.ImgUrl = require("../../../assets/pc/TopValidators/TopValidators4.png");
        }
        if (this.online == 1) {
          this.online = "Online";
        } else {
          this.online = "Offline";
          //   this.OnlineIndex = 1;
        }

        this.list = res.result.list;
        if (res.result.list.length > 0) {
          this.IsShowS = true;
        } else {
          this.IsShowS = false;
        }
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < this.list.length; i++) {
          let UTCTime =
            res.result.list[i].tradeTime - this.getClientTimezone * 3600000;
          this.TimeDate[i] = timestampConvertTime(UTCTime);
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
        }

        //     console.log(this.total);
      });
    },
    fromAddress(index) {
      this.$router.push({ path: "/pc/BkHash", query: { query: index } });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;

      return nd;
    },

    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>
<style>
.el-tooltip__popper.is-dark {
  background: rgba(36, 41, 49, 0.98) !important;
  border-radius: 10px 10px 10px 10px !important;
}
</style>

<style lang="less" scoped>
// .el-tooltip__popper {
//       background: red;
//     }
// /deep/.el-tooltip__popper.is-dark {
//       background: red;
//     }
.BlockList {
  width: 100%;

  // border: 1px solid red;
  background: #13161b;
  .BlockList-W {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;

    .BlockList_Inp {
      padding-top: 40px;
      padding-bottom: 20px;
    }
  }
}
.ValidatorBetail {
  width: 100%;
  background: #13161b;
  .ValidatorBetail-W {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;
    .Homeinput {
      padding: 10px 0;
    }
    .BkHeight_conent {
      background: #0b0c0f;
      border-radius: 16px 16px 16px 16px;
      padding: 20px 20px 12px 20px;
      margin-bottom: 30px;
      // border: 1px solid blue;
      .BkHeight_conent_header {
        p {
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            -webkit-background-clip: text;
            margin-left: 40px;
            margin-top: 40px;
          }
        }
      }
      .BkHeight_center {
        margin-top: 10px;
        margin-left: 40px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        .BkHeight_l {
          width: 48px;
          height: 46px;
          background: #1c2027;
          border-radius: 6px 6px 6px 6px;
          opacity: 1;
          img {
            width: 48px;
            height: 46px;
          }
        }
        .BkHeight_r {
          flex: 1;
          .BkHeight_rs {
            display: flex;
            .BK_name {
              font-size: 16px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              margin-left: 20px;
            }
            .Bk_vs {
              margin-left: 30px;
              font-size: 12px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #898b8d;
              margin-top: 6px;
            }
          }
          .BkHeight_rx {
            display: flex;
            margin-top: 12px;
            .address {
              font-size: 12px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              margin-left: 20px;
            }
            img {
              width: 22px;
              height: 22px;
              margin-left: 16px;
            }
          }
        }
        .BkHeight_rr {
          width: 117px;
          text-align: center;
          height: 36px;
          line-height: 36px;
          background: #13161b;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          cursor: pointer;
          font-family: Roboto, Roboto;
          font-weight: 500;
          font-size: 14px;
          color: #00e79a;
        }
      }
      .BkHeight_conent_Ul {
        margin-left: 40px;
        //  border: 1px solid red;
        margin-top: 26px;
        padding-top: 0;
        ul {
          li {
            display: flex;
            height: 40px;
            line-height: 40px;
            // border: 1px solid yellow;
            margin-bottom: 8px;
            p:nth-child(1) {
              flex: 0 0 12%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 40px;
              -webkit-background-clip: text;
              margin-right: 211px;
            }
            p:nth-child(2) {
              flex: 0 0 60%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 20px;
              line-height: 40px;
              -webkit-background-clip: text;
              img {
                width: 26px;
                height: 26px;
                margin-top: 6px;
              }
            }
          }
          li:nth-child(2) {
            p {
              img {
                width: 24px;
                height: 24px;
                margin-left: 20px;
                cursor: pointer;
              }
            }
          }
          li:nth-child(7) {
            p:nth-child(2) {
              color: #00a870;
            }
            .active {
              color: #e34d59 !important;
            }
          }
        }
      }
    }
    .Workload {
      width: 1160px;
      height: 193px;
      background: #0b0c0f;
      border-radius: 20px 20px 20px 20px;
      opacity: 1;
      margin: 20px auto;
      .Workload_list {
        margin-left: 40px;
        padding-top: 30px;
      }
      .Workload_head1 {
        height: 26px;
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        line-height: 26px;
        span {
          margin-left: 4px;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
        }
      }
      .Workload_con {
        margin-top: 36px;
        display: flex;
        .container {
          position: relative;
          width: 57px;
          // height: 71px;
          // background: #000000 !important;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          // border: 2px solid rgba(0, 231, 154, 0.6);
          margin-right: 30px;
          text-align: center;
        }

        .content {
          position: relative;
          padding: 10px;
          margin-bottom: 5px;
        }

        .progress {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          border-radius: 2px 2px 10px 10px;
          background-color: rgba(
            0,
            231,
            154,
            0.3
          ); /* 设置进度条背景颜色及透明度 */
          transition: height 0.3s ease; /* 添加过渡效果 */
        }
        .progressa {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          border-radius: 2px 2px 10px 10px;
          background-color: rgba(
            255,
            64,
            90,
            0.3
          ); /* 设置进度条背景颜色及透明度 */
          transition: height 0.3s ease; /* 添加过渡效果 */
        }

        .text {
          z-index: 1;
          .time1 {
            height: 23px;
            font-size: 16px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 23px;
            margin-top: 8px;
          }
        }

        .green {
          border: 2px solid rgba(0, 231, 154, 0.6);
          border-radius: 10px 10px 10px 10px;
        }

        .red {
          border: 2px solid rgba(255, 64, 90, 0.65);
          border-radius: 10px 10px 10px 10px;
        }

        .con_boxr {
          border: 2px solid rgba(255, 64, 90, 0.65);
          //background-color: rgba(255, 64, 90, 0.55) !important; /* 设置进度条的颜色 */
          height: 5px; /* 设置进度条的高度 */
        }
        .con_boxg {
          border: 2px solid rgba(0, 231, 154, 0.6);
          // background-color:rgba(0, 231, 154, 0.85) !important;
          height: 5px; /* 设置进度条的高度 */
        }
        .progress-bar {
          height: 5px; /* 设置进度条的高度 */
          background-color: blue; /* 设置进度条的颜色 */

          // top:100px;
          z-index: 999;
        }
        .con_box {
          width: 57px;
          height: 71px;
          // background: #000000 !important;
          border-radius: 10px 10px 10px 10px;
          opacity: 1;
          // border: 2px solid rgba(0, 231, 154, 0.6);
          margin-right: 30px;
          text-align: center;
          .time1 {
            height: 23px;
            font-size: 16px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 23px;
            margin-top: 8px;
          }
        }
        .tanks {
          width: 405px;
          height: 280px;
          // background: #242931;
          z-index: 999;
          background: rgba(36, 41, 49, 0.98);
          border-radius: 8px 8px 8px 8px;
          opacity: 1;
          .tanks_box {
            margin-left: 14px;
            padding-top: 12px;
            margin-right: 14px;
            .tanks_tit {
              display: flex;
              justify-content: space-between;
              .tanks_titl {
                height: 17px;
                font-size: 12px;
                font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                font-weight: 500;
                color: #8e9093;
                line-height: 17px;
              }
              img {
                width: 11px;
                height: 11px;
              }
            }
            .tanks_cons {
              margin-top: 8px;

              .consli {
                display: flex;
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #fff;
                line-height: 21px;
                span {
                  color: #8e9093;
                  margin-right: 4px;
                }
              }
            }
          }
        }
      }
    }
    .TopValidatorsList {
      padding-bottom: 40px;
    }
  }
}
.Blocks {
  padding: 20px 20px;
  background: #0b0c0f;
  border-radius: 16px 16px 16px 16px;
  .Block_Top {
    margin-bottom: 24px;
    display: flex;
    span {
      flex: 1;
    }
    span:nth-child(1) {
      font-size: 16px;
      font-family: SF Pro Text-Medium, SF Pro Text;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      line-height: 24px;
      -webkit-background-clip: text;
    }
  }
  .Block_list {
    .block_list_Top {
      display: flex;
      height: 62px;
      width: 1120px;
      background: #14151a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      padding: 0 20px;
      li {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        line-height: 62px;
        -webkit-background-clip: text;
      }
      li:nth-child(1) {
        flex: 0 0 40%;
      }
      li:nth-child(2) {
        flex: 0 0 40%;
      }
      li:nth-child(3) {
        flex: 0 0 20%;
        text-align: right;
        padding-right: 38px;
      }
    }
  }
  .Block_List_center {
    ul {
      // padding: 0 20px;
      li {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #22252e;
        line-height: 62px;
        p {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          // color: #ffffff;
          color: #898b8d;
          -webkit-background-clip: text;
        }
      }

      p:nth-child(1) {
        color: #ffffff;
        flex: 0 0 40%;
        span {
          width: 259px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
      p:nth-child(1):hover {
        color: #00e79a;
      }
      p:nth-child(2) {
        flex: 0 0 40%;
        color: #898b8d;
        span {
          position: relative;
          cursor: default;
          .Hover1 {
            display: none;
            .Hover {
              padding: 3px 10px;
              display: inline-block;
              line-height: 20px;
              position: absolute;
              top: -70px;
              left: 0px;
              background-color: #3c485c;
              border-radius: 5px;
              i {
                position: absolute;
                top: 18px;
                left: 40%;
                transform: rotate(180deg);
                color: #3c485c;
              }
            }
          }
        }
      }
      p:nth-child(2) {
        span:hover {
          .Hover1 {
            display: block !important;
          }
        }
      }
      p:nth-child(3) {
        color: #898b8d;
        flex: 0 0 20%;
        text-align: right;
        padding-right: 38px;
      }
    }
  }
  .Block_List_Bottom {
    margin-top: 20px;
  }
}
.Img {
  width: 100%;
  height: 400px;
  text-align: center;
  img {
    width: 350px;
    height: 250px;
    margin-top: 40px;
  }
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
